import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { Skeleton, Snackbar, SnackbarContent } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useContext } from 'react';
import { ThemeContext } from '../context';
import PhoneIcon from '@mui/icons-material/Phone';
import ScienceIcon from '@mui/icons-material/Science';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';

const Image = styled('img')({
  height: '41px',
});

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

export default function PrimarySearchAppBar() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [snackBarOpen, setSnackBarOpen] = React.useState(false)
  const [loadingImage, setLoadingImage] = React.useState(false)
  const { state } = useContext(ThemeContext);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const itemsInCart = state.items.length

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
//+56 2 2760 4483
  const handlePhoneClick = () => {    
    const phoneNumber = '+56227604483'; // Replace with the desired phone number
  
    if (/(android|webos|iphone|ipad|ipod|blackberry|windows phone)/i.test(navigator.userAgent)) {
      // window.location.href = `https://wa.me/${encodeURIComponent(phoneNumber)}`;
      window.location.href = `tel:${phoneNumber}`;
    } else {
      // Non-mobile device, copy phone number to clipboard
      navigator.clipboard.writeText(phoneNumber)
        .then(() => {
          setSnackBarOpen(true)
        })
        .catch((error) => {
          console.error('Failed copiando:', error);
        });
    }
  };
  

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messasges</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={1} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" style={{background: 'linear-gradient(to right bottom, #3480eb, #83CAF7)'}}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={() => navigate('/')}
          >
            {
              loadingImage && <Skeleton variant='rectangular' sx={{width:{xs:30, md:40}, height:{xs:30, md:40}}}  />
            }
            {/* <Skeleton variant='rectangular' sx={{width:{xs:30, md:40}, height:{xs:30, md:40}}}  /> */}
            <Image 
              onLoad={() => setLoadingImage(false)} 
              onLoadStart={() => setLoadingImage(true) } 
              src={require('../images/favicon.ico')} 
              sx={loadingImage? {display:'none'} : {width: {xs:33, md:40}, height: {xs:33, md:40},}} 
              
              />
            {/* <HomeIcon /> */}
          </IconButton>
          <Typography fontWeight={900} fontSize={25} display={{xs:'none', md:'block'}} >Fonoxia</Typography>
          {/* <Image src={require('../images/favicon.ico')} sx={{width: {xs:120, md:50}, height: {xs:35, md:50}}} /> */}
          {/* <Search sx={{display: {xs:'none'}}} >
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Buscar"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search> */}
          <Box sx={{ flexGrow: 1 }} />
          <Box >
            <Typography color={'white'} fontWeight='bold' sx={{ display: { xs: 'none', md:'contents'}}} >Demostración</Typography>
            <Typography color={'white'} fontWeight='bold' sx={{ display: { xs: 'contents', md:'none'}}} >Demo</Typography>
              <IconButton
                size="large"
                aria-label="notifications"
                color="inherit"
                onClick={() => navigate('/restaurant-demo')}
                // onClick={() => navigate('/Demostracion')}
              >
                <Badge badgeContent={2} color="error">
                  <ScienceIcon color='white'  />
                </Badge>
              </IconButton>
            <Typography sx={{ display: { xs: 'none', md:'contents'}}}>contacto@fonoxia.com</Typography>
            <IconButton size="large" aria-label="show 4 new mails" color="inherit" onClick={() => navigate('/contacto')}>
              {/* <Badge badgeContent={4} color="error"> */}              
                <MailIcon />
              {/* </Badge> */}
            </IconButton>
            
            <Typography sx={{ display: { xs: 'none', md:'contents'}}} >+56 2 2760 4483</Typography>
            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={handlePhoneClick}
            >
              {/* <Badge badgeContent={17} color="error"> */}
                <WhatsAppIcon />
              {/* </Badge> */}
            </IconButton>
            <Typography sx={{ display: { xs: 'none', md:'contents'}}}>Preguntas Frecuentes</Typography>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={() => navigate('/Preguntas-frecuentes')}
              color="inherit"
            >
              <ContactSupportIcon />
            </IconButton>

            <Typography sx={{ display: { xs: 'none', md:'contents'}}}>Acceso clientes</Typography>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={() => navigate('/Clientes/Login')}
              color="inherit"
            >
              <AccessibilityNewIcon />
            </IconButton>
            
          </Box>
          
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackBarOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <SnackbarContent
          message={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" align="center">
                Número copiado
              </Typography>
              <CheckCircleIcon style={{ marginLeft: '0.5em' }} />
            </div>
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      </Snackbar>
    </Box>
  );
}